module.exports = __webpack_public_path__ + "img/master.94e87d7b.png";